// Cookie consent state shared by the banner, GA4 (Basic Consent Mode) and Microsoft Clarity (Consent API v2).
// Nothing analytics-related is loaded until `analytics === true`; a stored choice expires after 6 months.
export const CONSENT_KEY = "vl_consent";
export const CONSENT_TTL_MS = 180 * 24 * 60 * 60 * 1000;
const EVT = "vl-consent-change";

export const readConsent = () => {
  try {
    const raw = window.localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const c = JSON.parse(raw);
    if (typeof c?.analytics !== "boolean") return null;
    if (c.ts && Date.now() - Date.parse(c.ts) > CONSENT_TTL_MS) return null;
    return c;
  } catch {
    return null;
  }
};

// True only when the visitor accepted analytics and the scripts are loaded and not disabled by a later withdrawal.
export const analyticsActive = () => Boolean(window.__vlAnalyticsLoaded) && !window.__vlAnalyticsDisabled;

// Loads GA4/Clarity on acceptance; on rejection/withdrawal blocks further hits and removes analytics cookies.
export const applyConsent = (analytics) => {
  const state = analytics ? "granted" : "denied";
  const gaId = window.GA_MEASUREMENT_ID;
  if (analytics) {
    window.__vlAnalyticsDisabled = false;
    if (gaId) window[`ga-disable-${gaId}`] = false;
    window.__vlLoadAnalytics?.();
  } else {
    window.__vlAnalyticsDisabled = true;
    if (gaId) window[`ga-disable-${gaId}`] = true;
  }
  if (window.__vlAnalyticsLoaded && typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      analytics_storage: state,
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    });
  }
  if (typeof window.clarity === "function") {
    try {
      window.clarity("consentv2", { ad_Storage: "denied", analytics_Storage: state });
      window.clarity(analytics ? "start" : "stop");
    } catch { /* clarity optional */ }
  }
  if (!analytics) clearAnalyticsCookies();
};

// Withdrawal must remove already-set analytics cookies (GA4 _ga/_ga_*, Clarity _clck/_clsk; ph_* = legacy PostHog cookies).
const clearAnalyticsCookies = () => {
  const parts = window.location.hostname.split(".");
  const domains = ["", window.location.hostname, ...parts.map((_, i) => "." + parts.slice(i).join(".")).filter((d) => d.split(".").length > 2)];
  document.cookie.split(";").map((c) => c.split("=")[0].trim()).forEach((name) => {
    if (/^(_ga|_gid|_gat|_clck|_clsk|ph_)/.test(name)) {
      domains.forEach((d) => {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${d ? `; domain=${d}` : ""}`;
      });
    }
  });
};

export const saveConsent = (analytics) => {
  const c = { analytics, ts: new Date().toISOString(), v: 2 };
  try { window.localStorage.setItem(CONSENT_KEY, JSON.stringify(c)); } catch { /* storage blocked */ }
  applyConsent(analytics);
  window.dispatchEvent(new CustomEvent(EVT, { detail: c }));
  return c;
};

export const openConsentSettings = () => window.dispatchEvent(new CustomEvent("vl-consent-open"));
export const onConsentChange = (fn) => {
  window.addEventListener(EVT, fn);
  return () => window.removeEventListener(EVT, fn);
};
